import React, { useState, useEffect } from 'react';
import { dateFormat, dateFormatConDiaShort, dateFormatConDiaYHoraShort } from '../../../../../utils/DateFunctions';

const ListaGradosDias = (p) => {
    const data = p.data ?? [];
    const enviarElementoAPadre = p.enviarElementoAPadre ?? (() => { });
    var counter = 0;

    const keyGen = () => {
        counter++;
        return counter + "lista";
    }

    return (
        <div className='bw-1200 round-m border shadow-sm bg-whitet text-center overflow p-2 pt-0' style={{ maxHeight: "75vh" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <table className='table table-sm table-hover'>
                    <thead>
                        <tr>
                            <th className='text-start border-end nowrap'>Fecha</th>
                            <th className='text-center nowrap'>Grados día</th>
                            <th className='text-center nowrap'>Evapotranspiración</th>
                            <th className='text-center nowrap'>Temp. Máx</th>
                            <th className='text-center nowrap'>Temp. Mín</th>
                            <th className='text-center nowrap'>Promedio</th>
                            <th className='text-start nowrap border-start'>Edición</th>
                            <th className='text-start nowrap'>Usuario</th>
                            <th className='text-center nowrap'>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((registro, i) =>
                            <tr className={registro.fecha_cancelacion ? "" : 'pointer'} key={keyGen()} id={'temp' + i} onClick={() => { if (!registro.fecha_cancelacion) enviarElementoAPadre(registro) }}>
                                <td className='text-start border-end nowrap text-bold'>{dateFormatConDiaShort(registro.fecha)}</td>
                                <td className='text-center nowrap'>{registro.gradosDia}</td>
                                <td className='text-center nowrap'>{registro.evapotranspiracion}</td>
                                <td className='text-center nowrap'>{registro.maxTemperatura} °C</td>
                                <td className='text-center nowrap'>{registro.minTemperatura} °C</td>
                                <td className='text-center nowrap'>{registro.promedioTemperatura} °C</td>
                                <td className='text-start nowrap border-start text-s'>{dateFormatConDiaYHoraShort(registro.fecha_actualizacion ?? registro.fecha_creacion)}</td>
                                <td className='text-start nowrap'>{registro.usuario_editor_nombre}</td>
                                <td className='text-center nowrap '>{!registro.fecha_cancelacion ? 'ACTIVO' : "CANCELADO"}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ListaGradosDias;